import { Component } from '@angular/core';

@Component({
  selector: 'allas-escribenos-ahora',
  imports: [],
  template: `
    <section
      class="shadow-lg flex flex-col xl:flex-row gap-2 items-center justify-between px-2 xl:px-28 py-12 mb-16 mt-6"
    >
      <div class="flex flex-col gap-2">
        <h2
          class="text-3xl xl:text-5xl font-bold fs-condensed text-appPrimary-500 text-center"
        >
          ¡ESCRÍBENOS AHORA!
        </h2>
        <p class="text-center text-appBlack text-sm xl:text-base">
          No esperes más. Obtén tu cotización al instante y <br />
          encuentra el mejor Repuesto al mejor precio del mercado.
        </p>
      </div>
      <div class="flex flex-col xl:flex-row gap-2 mt-6">
        <a
          href="https://wa.me/50422834540?text=Hola,%20necesito%20cotizar%20un%20repuesto.%20¿Podrían%20ayudarme?"
          class="text-center bg-whatsappGreen text-white px-6 py-2 xl:px-8 rounded-md fs-condensed hover:scale-105 transition-all duration-300"
        >
          COTIZAR AHORA
        </a>
        <a
          href="tel:+50422834540"
          class="border-appBlack border text-appBlack px-6 py-2 xl:px-8 rounded-md font-medium fs-condensed hover:scale-105 transition-all duration-300"
        >
          LLAMAR DIRECTAMENTE
        </a>
      </div>
    </section>
  `,
})
export class EscribenosAhora {}
